import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["navigationPriority", "groupName"],
  _excluded2 = ["props"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _sortBy from 'lodash/sortBy';
import _values from 'lodash/values';
function getIndividualLinks(links) {
  return links.filter(function (_ref) {
    var groupName = _ref.groupName;
    return _isEmpty(groupName);
  });
}
export function sortLinks(links) {
  return _sortBy(links, ['navigationPriority']);
}
export function createLinkGroups(links) {
  var groups = links.reduce(function (linkGroups, link) {
    var groupName = link.groupName;
    if (groupName) {
      return _objectSpread(_objectSpread({}, linkGroups), {}, _defineProperty({}, groupName, linkGroups[groupName] ? [].concat(_toConsumableArray(linkGroups[groupName]), [link]) : [link]));
    }
    return linkGroups;
  }, {});
  return Object.keys(groups).reduce(function (acc, groupName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, groupName, sortLinks(groups[groupName])));
  }, {});
}
function linksToGroupOfLinks(individualLinks, groupedLinks) {
  return [].concat(_toConsumableArray(individualLinks), _toConsumableArray(_values(groupedLinks))).map(function (linkOrGroup) {
    if (_isArray(linkOrGroup)) {
      var firstGroupItem = linkOrGroup[0];
      var groupName = firstGroupItem.groupName,
        navigationPriority = firstGroupItem.navigationPriority;
      return {
        navigationPriority: navigationPriority,
        title: groupName,
        links: linkOrGroup
      };
    }
    return linkOrGroup;
  });
}
export function cleanLinkProps(links) {
  return links.map(function (_ref2) {
    var navigationPriority = _ref2.navigationPriority,
      groupName = _ref2.groupName,
      link = _objectWithoutProperties(_ref2, _excluded);
    return link;
  });
}
export function transformLinks(links) {
  return links.map(function (link) {
    var props = link.props,
      rest = _objectWithoutProperties(link, _excluded2);
    if (props) {
      return _objectSpread(_objectSpread({}, JSON.parse(props)), rest);
    }
    return rest;
  });
}
export function groupLinks(links) {
  var transformedLinks = transformLinks(links);
  var individualLinks = getIndividualLinks(transformedLinks);
  var linkGroups = createLinkGroups(transformedLinks);
  var mergedLinks = linksToGroupOfLinks(individualLinks, linkGroups);
  var sortedLinks = sortLinks(mergedLinks);
  var cleanedLinks = cleanLinkProps(sortedLinks);
  return cleanedLinks;
}